import { ReactNode } from 'react';
import { useUiComponentsVisibility } from 'src/hooks/useUiComponentsVisibility';
import { ComponentsName } from 'src/interfaces/enums';

type Props = {
  children: ReactNode;
  componentName: ComponentsName;
};

export const WrapComponentVisibility = ({ children, componentName }: Props) => {
  const { canShowComponent } = useUiComponentsVisibility();

  if (!canShowComponent(componentName)) {
    return null;
  }

  return <>{children}</>;
};
